import * as d3 from 'd3'

export default {
  methods: {

    draw_Timeline_Week_Custom() {
      let height = 24
      let timeline = this.timeline
      let weekX = 0
      let nowMonth = ''
      let monthList = []

      this.canvasTimeline = this.canvasForm
      .append('g')
      .attr('transform', `translate(${timeline.x}, ${timeline.y})`)

      timeline.week.filter(f => f.sum <= timeline.maxCol).forEach((w, i) => {
        let date_ = new Date(w.date)

        if (nowMonth != d3.timeFormat('%b')(date_)) {
          nowMonth = d3.timeFormat('%b')(date_)

          monthList.push({ 
            year: w.year,
            month: w.month,
            name: nowMonth,
            x: weekX
          })
        }

        this.canvasTimeline
        .append('text')
        .attr('x', weekX + (((this.skyline.width + (this.skyline.gap * 2)) / 2) * w.col))
        .attr('y', 11)
        .attr('font-size', 9).attr('fill', '#333').attr('text-anchor', 'middle')
        .text(w.name)
        
        this.canvasTimeline
        .append('path')
        .attr('d', () => {
          if (i != 0) return `M${weekX}, 2 V 11`
        })
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)
        
        if(w.date == timeline.cutoff) {
          this.canvasTimeline
          .append('rect')
          .attr('x', weekX + .5).attr('y',.5)
          .attr('width', w.col * (this.skyline.width + (this.skyline.gap * 2)) -.5).attr('height',14)
          .attr('fill','#EC407A').attr('stroke','#bcbcbc').attr('stroke-width',0.5).attr('opacity', 0.2)   
        }

        weekX += ((this.skyline.width + (this.skyline.gap * 2)) * w.col)
      })

      // Month
      monthList.forEach((d,i)=> {
        let monthWidth = timeline.week.filter(f => f.sum <= timeline.maxCol && f.year == d.year && f.month == d.month).reduce((sum, item) => sum + (item.col || 0), 0) * (this.skyline.width + (this.skyline.gap * 2))

        this.canvasTimeline
        .append('text')
        .attr('x', d.x + monthWidth / 2).attr('y', 22)
        .attr('font-size', 9).attr('fill', '#000')
        .attr('text-anchor', 'middle')
        .text(d.name.toUpperCase())

        this.canvasTimeline
        .append('path')
        .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)
        .attr('d', () => {
          if (i != 0) return `M${d.x}, 11 V18`
        })
      })

      timeline.length = timeline.week.filter(f => f.sum <= timeline.maxCol).reduce((sum, item) => sum + (item.col || 0), 0) * (this.skyline.width + (this.skyline.gap * 2))

      let timeBox = this.canvasTimeline
      .append('g')
      .attr('id', `TIMEBOX`)
      .attr('transform', `translate(0,0)`)

      timeBox
      .append('path') // shadow
      .attr('d', `M5,${height + 4} H ${timeline.length-5} L ${timeline.length},${height + 7} H0 Z`)
      .attr('fill', `url(#shadowTimeline)`) 

      timeBox
      .append('rect') 
      .attr('x', 0).attr('y', 0).attr('width', timeline.length).attr('height', 2)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .99)

      timeBox
      .append('rect')
      .attr('x', 0).attr('y', 2).attr('width', timeline.length).attr('height', height)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .5)

      timeBox
      .append('rect') 
      .attr('x', 0).attr('y', height + 1).attr('width', timeline.length).attr('height', 3)
      .attr('fill', `url(#${this.localId}_LightGray_)`)

      d3.select(`#TIMEBOX`).moveToBack()
    },

  }
}
